/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .directive('zcsChartSingleLine', zcsChartSingleLine);

zcsChartSingleLine.$inject = ['$translate', 'currencies'];
function zcsChartSingleLine($translate, currencies) {
  return {
    scope: {
      chartData: '=',
      domainValues: '=',
      project: '=',
    },
    link(scope, elem, attrs) {
      // Show currency symbol or suffix on chart
      const currency = currencies[scope.project.currency];

      // Create a container for the chart
      const svgContainer = d3.select(elem[0]).append('svg');
      const X_AXIS_FORMAT = d3.time.format($translate.instant('sharedModules.dateTimeFormats.chart.monthDay'));
      const Y_AXIS_FORMAT = d3.format(',.0f');
      const HEIGHT = 300;

      // Draw a line chart
      return nv.addGraph(() => {
        const chart = nv.models.lineChart()
          .useInteractiveGuideline(true)
          .margin({
            right: 23,
            left: 23,
          })
          .height(HEIGHT)
          .showXAxis(true)
          .showYAxis(true)
          .showLegend(false)
          .duration(1000)
          .x(d => moment(d.x).valueOf())
          .xScale(d3.time.scale())
          .xDomain(scope.domainValues.x)
          .yDomain(scope.domainValues.y);

        const yValuesOver10k = _.chain(scope.chartData[0].values)
          .sortBy(d => d.y)
          .pickBy(d => d.y > 10000)
          .map(d => d.y)
          .value();

        chart.yAxis
          .ticks(4)
          .tickFormat(d => {
            if(yValuesOver10k.length > 1 && scope.project.currency === 'jpy') {
              return Y_AXIS_FORMAT(d / 10000) + '万円'; // only use this short version for Japanese yen
            }
            return currency.symbol + Y_AXIS_FORMAT(d) + currency.suffix;
          });

        chart.xAxis
          .ticks(6)
          .tickFormat(d => X_AXIS_FORMAT(new Date(d)));

        svgContainer
          .datum(scope.chartData)
          .transition()
          .call(chart);

        const adjustYAxisTextPosition = () => {
          // move the y axis labels on top of it's lines
          svgContainer.selectAll('.nv-y .tick text, .nv-y .nv-axisMaxMin text')
            .attr({
              transform: null,
              dy: -3,
              // TODO: make the x value adjust to label string length?
              dx: 36,
            });
        };

        adjustYAxisTextPosition();

        nv.utils.windowResize(() => {
          chart.update();
          adjustYAxisTextPosition();
        });

        return chart;
      }, chart => {
        chart.interactiveLayer.tooltip.contentGenerator(d => {
          let tooltipHTML = `
            <table>
              <thead>
                <tr>
                  <td colspan="3">
                    <strong class="x-value">${X_AXIS_FORMAT(new Date(d.value))}</strong>
                  </td>
                </tr>
              </thead>
              <tbody>
                ###TABLE_ROWS###
              </tbody>
            </table>`;

          const TABLE_ROWS = _.map(
            d.series,
            serie =>
              `<tr>
                <td class="legend-color-guide">
                  <div style="background-color:${serie.color};"></div>
                </td>
                <td class="key">${serie.key}</td>
                <td class="value">${currency.symbol + Y_AXIS_FORMAT(serie.value) + currency.suffix}</td>
              </tr>`
          )
            .join('\n');

          tooltipHTML = tooltipHTML.replace('###TABLE_ROWS###', TABLE_ROWS);

          return tooltipHTML;
        });

        return chart;
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/charts/chart_single_line.js